import Hamovniki from '../../screens/hamovniki';
export default Hamovniki;
